





















































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, getIndexFromList, excludeIdFromList, isNullOrEmpty, formatDate } from '../../core/utils';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { NormsServices } from '../api/NormsServices';
import { PageTitle } from '../../core/components';
import CreateDTC from '../components/CreateDTC.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Input from '../../core/components/Input.vue'; 

@Component({
    components: {
        CreateDTC,
        PageTitle,
        Input,
        SimpleTable
    }
})
export default class NormasDTCList extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    //create DTC props
    visibleModalCreateDTC: boolean = false;
    framesTypes: any = [];
    dtcToPatch: any = {};
    currentAction: string = '';
    categoriesOptions: any = [];
    editingDTC: boolean = false;

    //frames list
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [true];
    dataAssigned: boolean = false;
    loadingPreviewData: boolean = false;
    previewFrame: object = {};
    showModalCreateEcu: boolean = false;
    dtcToDelete: number | null = null;
    pendingRequest: boolean = false;
    showDeleteConfirmationDialog: boolean = false;
    deleteConfirmationTitle: string = 'Eliminar DTC';
    deleteConfirmationMessage: string = '¿Está seguro que desea eliminar esta DTC? Ésta acción no se podrá deshacer.';
    search: string = '';
    pendingProtocols: boolean = false;
    protocolSelected: any = null;
    protocolOptions: any = [];
    headers: any[] = [
        {
            text: 'ID',
            align: 'center',
            value: 'id',
            tooltip: ''
        },
        {
            text: 'Descripción',
            align: 'left',
            value: 'description',
            tooltip: ''
        },
        {
            text: 'Protocolo',
            align: 'center',
            value: 'protocol',
            width: '200',
            tooltip: ''
        },
        {
            text: 'Clasificación',
            align: 'center',
            value: 'classification.description',
            width: '200',
            tooltip: ''
        },
        {
            text: 'DTC Code',
            align: 'center',
            value: 'dtc',
            width: '200',
            tooltip: ''
        },
        {
            text: 'Marca',
            align: 'center',
            value: 'brand',
            width: '200',
            tooltip: '',
            formatter: this.formatBrand,
            filter: this.filterByBrand
        },
        {
            text: 'Ecu',
            align: 'center',
            value: 'ecu',
            width: '200',
            tooltip: '',

        },
        {
            text: 'Comentario',
            align: 'center',
            value: 'commentary',
            width: '200',
            tooltip: ''
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false,
            width: '120',
            tooltip: ''
        }
    ];
    items: any = [];
    pagination: object = {
        rowsPerPageItems: 18
    };
    protocolTypes: any = [];
    brandOptions: any = [];
    brandSelected: any = null;
    brandResetValue: boolean = false;
    classificationTypes: any = [];
    pendingRequestPatchFrame: boolean = false;
    isEmpty: Function = isNullOrEmpty;

    dateFormat(date){
        return formatDate(date, true);
    }

    updateBrandSelected(value) {
        this.brandSelected = value;
    }

    updateBrandResetValue(value) {
        this.brandResetValue = value;
    }

    existValidCommentary(commentary){
        if(isNullOrEmpty(commentary)){
            return false
        }
        if(isNullOrEmpty(commentary['text'])){
            return false;
        }
        return true;
    }




    mounted() {
        this.getListDTC();
    }
    

    updateSearchValue(value){
        this.search = value;
    }

     formatBrand(value) {
        return this.$_getNormsProperties['all_brands'][value] || value;
    }

    filterByBrand(value) {
        if(this.brandSelected == null){
            return true;
        }
        return value == Number(this.brandSelected['id']);
    }



    @Watch('$_getNormsProperties')
    watchNormsProperties() {
        this.dataAssigned = false;
        this.assignVariables();
    }

    convertDictionaryToList(obj) {
        let items: any = [];
        for (let i = 0; i < Object.keys(obj).length; i++) {
            items.push({
                id: Object.keys(obj)[i],
                value: Object.values(obj)[i]
            });
        }
        items.sort(sortObjectByPropertyName('value'));
        return items;
    }

    getDataFromNormsProperties(option) {
        return this.$_getNormsProperties[option];
    }

    trucate(value, length = 200) {
        return value.length <= length ? value : value.substring(0, length) + '...';
    }

    getListDTC() {
        this.pendingRequest = true;
        NormsServices.getDTCList(Axios.CancelToken.source())
            .then(response => {
                this.items = response
                this.pendingRequest = false;
                this.assignVariables();
            })
            .catch(error => {
                this.pendingRequest = false;
                this.assignVariables();
            });
    }

    assignVariables() {
        this.protocolTypes = this.convertDictionaryToList(this.getDataFromNormsProperties('all_protocols'));
        this.classificationTypes = this.getDataFromNormsProperties('all_dtc_classifications');
        this.brandOptions = this.convertDictionaryToList(this.getDataFromNormsProperties('all_brands'));
        this.dataAssigned = true;
    }

    createFrame() {
        this.protocolSelected = null;
        this.editingDTC = false;
        this.visibilityModalCreateDTC(true);
    }

    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    visibilityModalCreateDTC(value) {
        this.visibleModalCreateDTC = value;
        this.handleListenKey(false);
    }

    closeModalCreateDTC() {
        this.visibilityModalCreateDTC(false);
    }

    addNewDtc(newDTC) {
        let dtcToPush = {
            id: newDTC['id'],
            description: newDTC['description'],
            dtc: newDTC['dtc'],
            protocol: {
                name: newDTC['protocol']['value'],
                id: newDTC['protocol']['id']
            },
            classification: {
                id: newDTC['classification']['id'],
                description: newDTC['classification']['description']
            },
            brand: newDTC['brand'],
            ecu_address: newDTC['ecu_address'],
            commentary: newDTC['commentary']
        };

        this.items.push(dtcToPush);
        this.loadingParamsEffect();
        this.$_successPatchRecipients('DTC agregado');
    }

    updateProtocolSelected(option) {
        this.protocolSelected = option;
    }

    loadingParamsEffect() {
        this.pendingRequest = true;
        let allParams = this.items;
        this.items = [];
        this.items = allParams;

        setTimeout(() => {
            this.pendingRequest = false;
        }, 200);
    }

    updateDTC(newDTC) {
        console.clear();
        let previousItems = this.items;
        
        let self = this;
        let indexDtcInList = getIndexFromList(this.items, 'id', newDTC['id']);
        if (indexDtcInList !== -1) {
            this.items = [];
            this.pendingRequest = true;
            this.$set(previousItems[indexDtcInList], 'ecu', newDTC['ecu']);
            if(newDTC['commentary'] !== null){
                this.$set(previousItems[indexDtcInList]['commentary'], 'text', newDTC['commentary']['text']);
                this.$set(previousItems[indexDtcInList]['commentary'], 'timestamp', newDTC['commentary']['timestamp']);
                this.$set(previousItems[indexDtcInList]['commentary']['user'], 'username', newDTC['commentary']['user']['username']);
            }
            this.$set(previousItems[indexDtcInList], 'brand', newDTC['brand']);
            this.$set(previousItems[indexDtcInList], 'description', newDTC['description']);
            this.$set(previousItems[indexDtcInList]['classification'], 'id', newDTC['classification']['id']);
            this.$set(previousItems[indexDtcInList]['classification'], 'description', newDTC['classification']['description']);
            this.$set(previousItems[indexDtcInList], 'id', newDTC['id']);
            this.$set(previousItems[indexDtcInList], 'protocol', newDTC['protocol']);
            this.$set(previousItems[indexDtcInList], 'dtc', newDTC['dtc']);
        }

        setTimeout(() => {
            self.items = previousItems;
             self.pendingRequest = false;
        }, 500);
        this.loadingParamsEffect();
        this.$_successPatchRecipients('DTC actualizado');
    }

    modifyDTC(dtc) {
        let self = this;
        this.$set(dtc, 'isLoading', true);
        NormsServices.getDTCDetail(dtc['id'])
            .then(response => {
                self.editingDTC = true;
                self.dtcToPatch = response;
                self.visibilityModalCreateDTC(true);
                this.$set(dtc, 'isLoading', false);
            })
            .catch(error => {
                // self.handleCatchResponse(error);
                this.$set(dtc, 'isLoading', false);
            });
    }

    deleteFrame(item) {
        this.dtcToDelete = Number(item['id']);
        this.showDeleteConfirmationDialog = true;
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.pendingRequest = true;

            let idDtc: any = this.dtcToDelete;
            let self = this;

            NormsServices.deleteDTCById(idDtc)
                .then(response => {
                    this.items = excludeIdFromList(this.items, idDtc);
                    if (response && response.data && response.data.message) {
                        self.$_successDeleteRecipients(response['data']['message']);
                    } else {
                        self.$_successDeleteRecipients('DTC eliminada con éxito');
                    }
                    self.pendingRequest = false;
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        self.$_errorPatchRecipients(error.response.data.message);
                    } else {
                        self.$_errorPatchRecipients('No se pudo eliminar la DTC');
                    }
                    this.pendingRequest = false;
                });
        }
        this.showDeleteConfirmationDialog = false;
    }
}
